module.exports = __webpack_public_path__ + "assets/img/1.badb3fc6.png";